// El motor de paginación de la flota: TanStack Table sobre los equipos YA filtrados y ordenados.
//
// El filtro vive en `logic.ts` y el orden en la tabla; aquí solo se corta lo cargado en páginas, que
// es lo que leen los controles del pie (ESTANDAR-TABLAS §5.4).
import {
    getCoreRowModel,
    getPaginationRowModel,
    useReactTable,
    type ColumnDef,
    type Table,
} from '@tanstack/react-table';
import { MDM_FLEET_PAGE_SIZE, type MdmFleetDevice } from '../types';

// Referencia estable: `useReactTable` compara `columns` por referencia igual que `data`. El pintado
// de las columnas vive en `MdmFleetTable`, así que el motor no declara ninguna.
const NO_COLUMNS: ColumnDef<MdmFleetDevice>[] = [];

export function useMdmFleetPaginationTable(rows: MdmFleetDevice[]): Table<MdmFleetDevice> {
    return useReactTable({
        data: rows,
        columns: NO_COLUMNS,
        getCoreRowModel: getCoreRowModel(),
        getPaginationRowModel: getPaginationRowModel(),
        initialState: { pagination: { pageSize: MDM_FLEET_PAGE_SIZE } },
        // La página la reinicia `MdmPage` cuando cambia el filtro o el orden. Cada «Cargar más»
        // trae un arreglo nuevo de nueve streams, y reiniciar en cada uno saca al operador.
        autoResetPageIndex: false,
    });
}
